const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSScribble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-scribble",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-scribble1",
    serifid: "iconS-scribble"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.886,4.901c-0.486,-0.486 -1.302,-0.502 -1.772,-0.038l-6.098,5.612c-0.513,0.469 -1.312,0.438 -1.784,-0.075c-0.473,-0.513 -0.439,-1.314 0.074,-1.784l6.095,-5.611c1.504,-1.381 3.828,-1.333 5.268,0.11c1.457,1.456 1.492,3.808 0.079,5.304l-7.841,8.299c-0.252,0.272 -0.272,0.686 -0.039,0.974c0.28,0.351 0.809,0.34 1.117,0.048l8.788,-9.246c1.381,-1.456 3.685,-1.484 5.07,-0.067c1.303,1.302 1.433,3.386 0.253,4.802l-3.504,4.203c-0.411,0.493 -0.379,1.223 0.079,1.677c0.438,0.438 1.128,0.489 1.626,0.114l0.785,-0.588c0.556,-0.418 1.314,-0.303 1.768,0.253c0.418,0.556 0.304,1.314 -0.253,1.768l-0.785,0.588c-1.5,1.128 -3.603,0.978 -4.929,-0.347c-1.377,-1.382 -1.48,-3.584 -0.229,-5.083l3.501,-4.203c0.343,-0.446 0.315,-1.018 -0.064,-1.432c-0.414,-0.379 -1.085,-0.371 -1.523,0.051l-8.752,9.25c-1.366,1.436 -3.717,1.338 -4.92,-0.209c-1.018,-1.275 -0.943,-3.102 0.176,-4.286l7.837,-8.298c0.478,-0.506 0.466,-1.296 -0.023,-1.786Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSScribble);
export default __webpack_public_path__ + "static/media/iconS-scribble.475d1639e9445ee056718e1481d8ebf3.svg";
export { ForwardRef as ReactComponent };